import { render } from "./Heading.vue?vue&type=template&id=96a56cfc&ts=true"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__